var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_431_2464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3V7.95762H7.95762V3H3ZM6.54237 6.54237H4.41737V4.41737H6.54237V6.54237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 15.0424V20H7.95762V15.0424H3ZM6.54237 18.5848H4.41737V16.4598H6.54237V18.5848Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0425 3V7.95762H20.0001V3H15.0425ZM18.5849 6.54237H16.4599V4.41737H18.5849V6.54237Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5827 9.375V13.625H15.0425V15.0424H20.0001V9.375H18.5827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0425 16.4576V20H16.4577V17.875H18.5827V20H20.0001V16.4576H15.0425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 3V4.41737H12.2076V7.95762H13.625V3H9.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2076 9.375V12.2076H9.375V16.4576H12.2076V20H13.625V15.0424H10.7924V13.625H13.625V10.7924H15.0424V12.2076H16.4576V9.375H12.2076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7924 17.875H9.375V20H10.7924V17.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.95752 12.2076H5.83252V13.625H7.95752V12.2076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5.83261V9.37499H3V13.625H4.41738V10.7924H10.7924V5.83261H9.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_431_2464"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.4248cbc757a8f453b8f337e6c554e9f3.svg";
export { ForwardRef as ReactComponent };